
import React, { useEffect, useState } from "react"
import ApiService from 'services';
import { Table, Row, Col } from 'react-bootstrap';
import TCABreadCrumb from 'components/breadcrumb';
import LoadingBar from 'components/LoadingBar';

function getIndex(index) {
    return index + 1;
}
export default function Grounds() {
    const [grounds, setGrounds] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
            try {
                let response = await ApiService.getGrounds();
                setGrounds(response.Record);
                setLoading(false);
            } catch (error) {
                // Handle error
                console.log(error);
            }
        };
        fetchData();
    }, []);
    return (
        <>
            <div>
                <Row>
                    <Col>
                        <h1>Grounds</h1>
                    </Col>
                </Row>
                {loading && <LoadingBar show={loading} />}
                {!loading &&
                <Row>
                    <Col>
                        <Table responsive striped bordered hover>
                            <thead>
                                <tr>
                                    <th>S.No.</th>
                                    <th>Name</th>
                                    <th>Address</th>

                                </tr>
                            </thead>
                            <tbody>
                                {grounds && grounds.length > 0 && grounds.sort(function (a, b) { return a.Name > b.Name ? 1 : -1; }).map((venue, index) => {
                                    return <tr key={index}>
                                        <td>{getIndex(index)}.</td>
                                        <td><a href={venue.Link} target="_new">{venue.Name}</a></td>
                                        <td><a href={"https://maps.google.com/?q="+venue.Address+","+venue.City+","+venue.Zip} target="_new">{venue.Address}, {venue.City}-{venue.Zip}</a></td>
                                    </tr>
                                })}
                            </tbody>
                        </Table>
                    </Col>
                </Row>}
            </div>
        </>
    )
}